/* eslint-disable import/no-default-export */
export default {
  100: require('resources/images/emoji/100.png'),
  1234: require('resources/images/emoji/1234.png'),
  '+1': require('resources/images/emoji/thumbsup.png'),
  '-1': require('resources/images/emoji/thumbsdown.png'),
  '8ball': require('resources/images/emoji/8ball.png'),
  a: require('resources/images/emoji/a.png'),
  ab: require('resources/images/emoji/ab.png'),
  abc: require('resources/images/emoji/abc.png'),
  abcd: require('resources/images/emoji/abcd.png'),
  accept: require('resources/images/emoji/accept.png'),
  aerial_tramway: require('resources/images/emoji/aerial_tramway.png'),
  airplane: require('resources/images/emoji/airplane.png'),
  alarm_clock: require('resources/images/emoji/alarm_clock.png'),
  alien: require('resources/images/emoji/alien.png'),
  ambulance: require('resources/images/emoji/ambulance.png'),
  anchor: require('resources/images/emoji/anchor.png'),
  angel: require('resources/images/emoji/angel.png'),
  anger: require('resources/images/emoji/anger.png'),
  angry: require('resources/images/emoji/angry.png'),
  anguished: require('resources/images/emoji/anguished.png'),
  ant: require('resources/images/emoji/ant.png'),
  apple: require('resources/images/emoji/apple.png'),
  aquarius: require('resources/images/emoji/aquarius.png'),
  aries: require('resources/images/emoji/aries.png'),
  arrow_backward: require('resources/images/emoji/arrow_backward.png'),
  arrow_double_down: require('resources/images/emoji/arrow_double_down.png'),
  arrow_double_up: require('resources/images/emoji/arrow_double_up.png'),
  arrow_down: require('resources/images/emoji/arrow_down.png'),
  arrow_down_small: require('resources/images/emoji/arrow_down_small.png'),
  arrow_forward: require('resources/images/emoji/arrow_forward.png'),
  arrow_heading_down: require('resources/images/emoji/arrow_heading_down.png'),
  arrow_heading_up: require('resources/images/emoji/arrow_heading_up.png'),
  arrow_left: require('resources/images/emoji/arrow_left.png'),
  arrow_lower_left: require('resources/images/emoji/arrow_lower_left.png'),
  arrow_lower_right: require('resources/images/emoji/arrow_lower_right.png'),
  arrow_right: require('resources/images/emoji/arrow_right.png'),
  arrow_right_hook: require('resources/images/emoji/arrow_right_hook.png'),
  arrow_up: require('resources/images/emoji/arrow_up.png'),
  arrow_up_down: require('resources/images/emoji/arrow_up_down.png'),
  arrow_up_small: require('resources/images/emoji/arrow_up_small.png'),
  arrow_upper_left: require('resources/images/emoji/arrow_upper_left.png'),
  arrow_upper_right: require('resources/images/emoji/arrow_upper_right.png'),
  arrows_clockwise: require('resources/images/emoji/arrows_clockwise.png'),
  arrows_counterclockwise: require('resources/images/emoji/arrows_counterclockwise.png'),
  art: require('resources/images/emoji/art.png'),
  articulated_lorry: require('resources/images/emoji/articulated_lorry.png'),
  astonished: require('resources/images/emoji/astonished.png'),
  athletic_shoe: require('resources/images/emoji/athletic_shoe.png'),
  atm: require('resources/images/emoji/atm.png'),
  b: require('resources/images/emoji/b.png'),
  baby: require('resources/images/emoji/baby.png'),
  baby_bottle: require('resources/images/emoji/baby_bottle.png'),
  baby_chick: require('resources/images/emoji/baby_chick.png'),
  baby_symbol: require('resources/images/emoji/baby_symbol.png'),
  back: require('resources/images/emoji/back.png'),
  baggage_claim: require('resources/images/emoji/baggage_claim.png'),
  balloon: require('resources/images/emoji/balloon.png'),
  ballot_box_with_check: require('resources/images/emoji/ballot_box_with_check.png'),
  bamboo: require('resources/images/emoji/bamboo.png'),
  banana: require('resources/images/emoji/banana.png'),
  bangbang: require('resources/images/emoji/bangbang.png'),
  bank: require('resources/images/emoji/bank.png'),
  bar_chart: require('resources/images/emoji/bar_chart.png'),
  barber: require('resources/images/emoji/barber.png'),
  baseball: require('resources/images/emoji/baseball.png'),
  basketball: require('resources/images/emoji/basketball.png'),
  bath: require('resources/images/emoji/bath.png'),
  bathtub: require('resources/images/emoji/bathtub.png'),
  battery: require('resources/images/emoji/battery.png'),
  bear: require('resources/images/emoji/bear.png'),
  bee: require('resources/images/emoji/bee.png'),
  beer: require('resources/images/emoji/beer.png'),
  beers: require('resources/images/emoji/beers.png'),
  beetle: require('resources/images/emoji/beetle.png'),
  beginner: require('resources/images/emoji/beginner.png'),
  bell: require('resources/images/emoji/bell.png'),
  bento: require('resources/images/emoji/bento.png'),
  bicyclist: require('resources/images/emoji/bicyclist.png'),
  bike: require('resources/images/emoji/bike.png'),
  bikini: require('resources/images/emoji/bikini.png'),
  bird: require('resources/images/emoji/bird.png'),
  birthday: require('resources/images/emoji/birthday.png'),
  black_circle: require('resources/images/emoji/black_circle.png'),
  black_joker: require('resources/images/emoji/black_joker.png'),
  black_large_square: require('resources/images/emoji/black_large_square.png'),
  black_medium_small_square: require('resources/images/emoji/black_medium_small_square.png'),
  black_medium_square: require('resources/images/emoji/black_medium_square.png'),
  black_nib: require('resources/images/emoji/black_nib.png'),
  black_small_square: require('resources/images/emoji/black_small_square.png'),
  black_square_button: require('resources/images/emoji/black_square_button.png'),
  blossom: require('resources/images/emoji/blossom.png'),
  blowfish: require('resources/images/emoji/blowfish.png'),
  blue_book: require('resources/images/emoji/blue_book.png'),
  blue_car: require('resources/images/emoji/blue_car.png'),
  blue_heart: require('resources/images/emoji/blue_heart.png'),
  blush: require('resources/images/emoji/blush.png'),
  boar: require('resources/images/emoji/boar.png'),
  boat: require('resources/images/emoji/boat.png'),
  bomb: require('resources/images/emoji/bomb.png'),
  book: require('resources/images/emoji/book.png'),
  bookmark: require('resources/images/emoji/bookmark.png'),
  bookmark_tabs: require('resources/images/emoji/bookmark_tabs.png'),
  books: require('resources/images/emoji/books.png'),
  boom: require('resources/images/emoji/boom.png'),
  boot: require('resources/images/emoji/boot.png'),
  bouquet: require('resources/images/emoji/bouquet.png'),
  bow: require('resources/images/emoji/bow.png'),
  bowling: require('resources/images/emoji/bowling.png'),
  bowtie: require('resources/images/emoji/bowtie.png'),
  boy: require('resources/images/emoji/boy.png'),
  bread: require('resources/images/emoji/bread.png'),
  bride_with_veil: require('resources/images/emoji/bride_with_veil.png'),
  bridge_at_night: require('resources/images/emoji/bridge_at_night.png'),
  briefcase: require('resources/images/emoji/briefcase.png'),
  broken_heart: require('resources/images/emoji/broken_heart.png'),
  bug: require('resources/images/emoji/bug.png'),
  bulb: require('resources/images/emoji/bulb.png'),
  bullettrain_front: require('resources/images/emoji/bullettrain_front.png'),
  bullettrain_side: require('resources/images/emoji/bullettrain_side.png'),
  bus: require('resources/images/emoji/bus.png'),
  busstop: require('resources/images/emoji/busstop.png'),
  bust_in_silhouette: require('resources/images/emoji/bust_in_silhouette.png'),
  busts_in_silhouette: require('resources/images/emoji/busts_in_silhouette.png'),
  cactus: require('resources/images/emoji/cactus.png'),
  cake: require('resources/images/emoji/cake.png'),
  calendar: require('resources/images/emoji/calendar.png'),
  calling: require('resources/images/emoji/calling.png'),
  camel: require('resources/images/emoji/camel.png'),
  camera: require('resources/images/emoji/camera.png'),
  cancer: require('resources/images/emoji/cancer.png'),
  candy: require('resources/images/emoji/candy.png'),
  capital_abcd: require('resources/images/emoji/capital_abcd.png'),
  capricorn: require('resources/images/emoji/capricorn.png'),
  car: require('resources/images/emoji/car.png'),
  card_index: require('resources/images/emoji/card_index.png'),
  carousel_horse: require('resources/images/emoji/carousel_horse.png'),
  cat: require('resources/images/emoji/cat.png'),
  cat2: require('resources/images/emoji/cat2.png'),
  cd: require('resources/images/emoji/cd.png'),
  chart: require('resources/images/emoji/chart.png'),
  chart_with_downwards_trend: require('resources/images/emoji/chart_with_downwards_trend.png'),
  chart_with_upwards_trend: require('resources/images/emoji/chart_with_upwards_trend.png'),
  checkered_flag: require('resources/images/emoji/checkered_flag.png'),
  cherries: require('resources/images/emoji/cherries.png'),
  cherry_blossom: require('resources/images/emoji/cherry_blossom.png'),
  chestnut: require('resources/images/emoji/chestnut.png'),
  chicken: require('resources/images/emoji/chicken.png'),
  children_crossing: require('resources/images/emoji/children_crossing.png'),
  chocolate_bar: require('resources/images/emoji/chocolate_bar.png'),
  christmas_tree: require('resources/images/emoji/christmas_tree.png'),
  church: require('resources/images/emoji/church.png'),
  cinema: require('resources/images/emoji/cinema.png'),
  circus_tent: require('resources/images/emoji/circus_tent.png'),
  city_sunrise: require('resources/images/emoji/city_sunrise.png'),
  city_sunset: require('resources/images/emoji/city_sunset.png'),
  cl: require('resources/images/emoji/cl.png'),
  clap: require('resources/images/emoji/clap.png'),
  clapper: require('resources/images/emoji/clapper.png'),
  clipboard: require('resources/images/emoji/clipboard.png'),
  clock1: require('resources/images/emoji/clock1.png'),
  clock10: require('resources/images/emoji/clock10.png'),
  clock1030: require('resources/images/emoji/clock1030.png'),
  clock11: require('resources/images/emoji/clock11.png'),
  clock1130: require('resources/images/emoji/clock1130.png'),
  clock12: require('resources/images/emoji/clock12.png'),
  clock1230: require('resources/images/emoji/clock1230.png'),
  clock130: require('resources/images/emoji/clock130.png'),
  clock2: require('resources/images/emoji/clock2.png'),
  clock230: require('resources/images/emoji/clock230.png'),
  clock3: require('resources/images/emoji/clock3.png'),
  clock330: require('resources/images/emoji/clock330.png'),
  clock4: require('resources/images/emoji/clock4.png'),
  clock430: require('resources/images/emoji/clock430.png'),
  clock5: require('resources/images/emoji/clock5.png'),
  clock530: require('resources/images/emoji/clock530.png'),
  clock6: require('resources/images/emoji/clock6.png'),
  clock630: require('resources/images/emoji/clock630.png'),
  clock7: require('resources/images/emoji/clock7.png'),
  clock730: require('resources/images/emoji/clock730.png'),
  clock8: require('resources/images/emoji/clock8.png'),
  clock830: require('resources/images/emoji/clock830.png'),
  clock9: require('resources/images/emoji/clock9.png'),
  clock930: require('resources/images/emoji/clock930.png'),
  closed_book: require('resources/images/emoji/closed_book.png'),
  closed_lock_with_key: require('resources/images/emoji/closed_lock_with_key.png'),
  closed_umbrella: require('resources/images/emoji/closed_umbrella.png'),
  cloud: require('resources/images/emoji/cloud.png'),
  clubs: require('resources/images/emoji/clubs.png'),
  cn: require('resources/images/emoji/cn.png'),
  cocktail: require('resources/images/emoji/cocktail.png'),
  coffee: require('resources/images/emoji/coffee.png'),
  cold_sweat: require('resources/images/emoji/cold_sweat.png'),
  collision: require('resources/images/emoji/collision.png'),
  computer: require('resources/images/emoji/computer.png'),
  confetti_ball: require('resources/images/emoji/confetti_ball.png'),
  confounded: require('resources/images/emoji/confounded.png'),
  confused: require('resources/images/emoji/confused.png'),
  congratulations: require('resources/images/emoji/congratulations.png'),
  construction: require('resources/images/emoji/construction.png'),
  construction_worker: require('resources/images/emoji/construction_worker.png'),
  convenience_store: require('resources/images/emoji/convenience_store.png'),
  cookie: require('resources/images/emoji/cookie.png'),
  cool: require('resources/images/emoji/cool.png'),
  cop: require('resources/images/emoji/cop.png'),
  copyright: require('resources/images/emoji/copyright.png'),
  corn: require('resources/images/emoji/corn.png'),
  couple: require('resources/images/emoji/couple.png'),
  couple_with_heart: require('resources/images/emoji/couple_with_heart.png'),
  couplekiss: require('resources/images/emoji/couplekiss.png'),
  cow: require('resources/images/emoji/cow.png'),
  cow2: require('resources/images/emoji/cow2.png'),
  credit_card: require('resources/images/emoji/credit_card.png'),
  crescent_moon: require('resources/images/emoji/crescent_moon.png'),
  crocodile: require('resources/images/emoji/crocodile.png'),
  crossed_flags: require('resources/images/emoji/crossed_flags.png'),
  crown: require('resources/images/emoji/crown.png'),
  cry: require('resources/images/emoji/cry.png'),
  crying_cat_face: require('resources/images/emoji/crying_cat_face.png'),
  crystal_ball: require('resources/images/emoji/crystal_ball.png'),
  cupid: require('resources/images/emoji/cupid.png'),
  curly_loop: require('resources/images/emoji/curly_loop.png'),
  currency_exchange: require('resources/images/emoji/currency_exchange.png'),
  curry: require('resources/images/emoji/curry.png'),
  custard: require('resources/images/emoji/custard.png'),
  customs: require('resources/images/emoji/customs.png'),
  cyclone: require('resources/images/emoji/cyclone.png'),
  dancer: require('resources/images/emoji/dancer.png'),
  dancers: require('resources/images/emoji/dancers.png'),
  dango: require('resources/images/emoji/dango.png'),
  dart: require('resources/images/emoji/dart.png'),
  dash: require('resources/images/emoji/dash.png'),
  date: require('resources/images/emoji/date.png'),
  de: require('resources/images/emoji/de.png'),
  deciduous_tree: require('resources/images/emoji/deciduous_tree.png'),
  department_store: require('resources/images/emoji/department_store.png'),
  diamond_shape_with_a_dot_inside: require('resources/images/emoji/diamond_shape_with_a_dot_inside.png'),
  diamonds: require('resources/images/emoji/diamonds.png'),
  disappointed: require('resources/images/emoji/disappointed.png'),
  disappointed_relieved: require('resources/images/emoji/disappointed_relieved.png'),
  dizzy: require('resources/images/emoji/dizzy.png'),
  dizzy_face: require('resources/images/emoji/dizzy_face.png'),
  do_not_litter: require('resources/images/emoji/do_not_litter.png'),
  dog: require('resources/images/emoji/dog.png'),
  dog2: require('resources/images/emoji/dog2.png'),
  dollar: require('resources/images/emoji/dollar.png'),
  dolls: require('resources/images/emoji/dolls.png'),
  dolphin: require('resources/images/emoji/dolphin.png'),
  door: require('resources/images/emoji/door.png'),
  doughnut: require('resources/images/emoji/doughnut.png'),
  dragon: require('resources/images/emoji/dragon.png'),
  dragon_face: require('resources/images/emoji/dragon_face.png'),
  dress: require('resources/images/emoji/dress.png'),
  dromedary_camel: require('resources/images/emoji/dromedary_camel.png'),
  droplet: require('resources/images/emoji/droplet.png'),
  dvd: require('resources/images/emoji/dvd.png'),
  'e-mail': require('resources/images/emoji/e-mail.png'),
  ear: require('resources/images/emoji/ear.png'),
  ear_of_rice: require('resources/images/emoji/ear_of_rice.png'),
  earth_africa: require('resources/images/emoji/earth_africa.png'),
  earth_americas: require('resources/images/emoji/earth_americas.png'),
  earth_asia: require('resources/images/emoji/earth_asia.png'),
  egg: require('resources/images/emoji/egg.png'),
  eggplant: require('resources/images/emoji/eggplant.png'),
  eight: require('resources/images/emoji/eight.png'),
  eight_pointed_black_star: require('resources/images/emoji/eight_pointed_black_star.png'),
  eight_spoked_asterisk: require('resources/images/emoji/eight_spoked_asterisk.png'),
  electric_plug: require('resources/images/emoji/electric_plug.png'),
  elephant: require('resources/images/emoji/elephant.png'),
  email: require('resources/images/emoji/email.png'),
  end: require('resources/images/emoji/end.png'),
  envelope: require('resources/images/emoji/envelope.png'),
  envelope_with_arrow: require('resources/images/emoji/envelope_with_arrow.png'),
  es: require('resources/images/emoji/es.png'),
  euro: require('resources/images/emoji/euro.png'),
  european_castle: require('resources/images/emoji/european_castle.png'),
  european_post_office: require('resources/images/emoji/european_post_office.png'),
  evergreen_tree: require('resources/images/emoji/evergreen_tree.png'),
  exclamation: require('resources/images/emoji/exclamation.png'),
  expressionless: require('resources/images/emoji/expressionless.png'),
  eyeglasses: require('resources/images/emoji/eyeglasses.png'),
  eyes: require('resources/images/emoji/eyes.png'),
  facepalm: require('resources/images/emoji/facepalm.png'),
  facepunch: require('resources/images/emoji/facepunch.png'),
  factory: require('resources/images/emoji/factory.png'),
  fallen_leaf: require('resources/images/emoji/fallen_leaf.png'),
  family: require('resources/images/emoji/family.png'),
  fast_forward: require('resources/images/emoji/fast_forward.png'),
  fax: require('resources/images/emoji/fax.png'),
  fearful: require('resources/images/emoji/fearful.png'),
  feelsgood: require('resources/images/emoji/feelsgood.png'),
  feet: require('resources/images/emoji/feet.png'),
  ferris_wheel: require('resources/images/emoji/ferris_wheel.png'),
  file_folder: require('resources/images/emoji/file_folder.png'),
  finnadie: require('resources/images/emoji/finnadie.png'),
  fire: require('resources/images/emoji/fire.png'),
  fire_engine: require('resources/images/emoji/fire_engine.png'),
  fireworks: require('resources/images/emoji/fireworks.png'),
  first_quarter_moon: require('resources/images/emoji/first_quarter_moon.png'),
  first_quarter_moon_with_face: require('resources/images/emoji/first_quarter_moon_with_face.png'),
  fish: require('resources/images/emoji/fish.png'),
  fish_cake: require('resources/images/emoji/fish_cake.png'),
  fishing_pole_and_fish: require('resources/images/emoji/fishing_pole_and_fish.png'),
  fist: require('resources/images/emoji/fist.png'),
  five: require('resources/images/emoji/five.png'),
  flags: require('resources/images/emoji/flags.png'),
  flashlight: require('resources/images/emoji/flashlight.png'),
  flipper: require('resources/images/emoji/flipper.png'),
  floppy_disk: require('resources/images/emoji/floppy_disk.png'),
  flower_playing_cards: require('resources/images/emoji/flower_playing_cards.png'),
  flushed: require('resources/images/emoji/flushed.png'),
  foggy: require('resources/images/emoji/foggy.png'),
  football: require('resources/images/emoji/football.png'),
  footprints: require('resources/images/emoji/footprints.png'),
  fork_and_knife: require('resources/images/emoji/fork_and_knife.png'),
  fountain: require('resources/images/emoji/fountain.png'),
  four: require('resources/images/emoji/four.png'),
  four_leaf_clover: require('resources/images/emoji/four_leaf_clover.png'),
  fr: require('resources/images/emoji/fr.png'),
  free: require('resources/images/emoji/free.png'),
  fried_shrimp: require('resources/images/emoji/fried_shrimp.png'),
  fries: require('resources/images/emoji/fries.png'),
  frog: require('resources/images/emoji/frog.png'),
  frowning: require('resources/images/emoji/frowning.png'),
  fu: require('resources/images/emoji/fu.png'),
  fuelpump: require('resources/images/emoji/fuelpump.png'),
  full_moon: require('resources/images/emoji/full_moon.png'),
  full_moon_with_face: require('resources/images/emoji/full_moon_with_face.png'),
  game_die: require('resources/images/emoji/game_die.png'),
  gb: require('resources/images/emoji/gb.png'),
  gem: require('resources/images/emoji/gem.png'),
  gemini: require('resources/images/emoji/gemini.png'),
  ghost: require('resources/images/emoji/ghost.png'),
  gift: require('resources/images/emoji/gift.png'),
  gift_heart: require('resources/images/emoji/gift_heart.png'),
  girl: require('resources/images/emoji/girl.png'),
  globe_with_meridians: require('resources/images/emoji/globe_with_meridians.png'),
  goat: require('resources/images/emoji/goat.png'),
  goberserk: require('resources/images/emoji/goberserk.png'),
  godmode: require('resources/images/emoji/godmode.png'),
  golf: require('resources/images/emoji/golf.png'),
  grapes: require('resources/images/emoji/grapes.png'),
  green_apple: require('resources/images/emoji/green_apple.png'),
  green_book: require('resources/images/emoji/green_book.png'),
  green_heart: require('resources/images/emoji/green_heart.png'),
  grey_exclamation: require('resources/images/emoji/grey_exclamation.png'),
  grey_question: require('resources/images/emoji/grey_question.png'),
  grimacing: require('resources/images/emoji/grimacing.png'),
  grin: require('resources/images/emoji/grin.png'),
  grinning: require('resources/images/emoji/grinning.png'),
  guardsman: require('resources/images/emoji/guardsman.png'),
  guitar: require('resources/images/emoji/guitar.png'),
  gun: require('resources/images/emoji/gun.png'),
  haircut: require('resources/images/emoji/haircut.png'),
  hamburger: require('resources/images/emoji/hamburger.png'),
  hammer: require('resources/images/emoji/hammer.png'),
  hamster: require('resources/images/emoji/hamster.png'),
  hand: require('resources/images/emoji/hand.png'),
  handbag: require('resources/images/emoji/handbag.png'),
  hankey: require('resources/images/emoji/hankey.png'),
  hash: require('resources/images/emoji/hash.png'),
  hatched_chick: require('resources/images/emoji/hatched_chick.png'),
  hatching_chick: require('resources/images/emoji/hatching_chick.png'),
  headphones: require('resources/images/emoji/headphones.png'),
  hear_no_evil: require('resources/images/emoji/hear_no_evil.png'),
  heart: require('resources/images/emoji/heart.png'),
  heart_decoration: require('resources/images/emoji/heart_decoration.png'),
  heart_eyes: require('resources/images/emoji/heart_eyes.png'),
  heart_eyes_cat: require('resources/images/emoji/heart_eyes_cat.png'),
  heartbeat: require('resources/images/emoji/heartbeat.png'),
  heartpulse: require('resources/images/emoji/heartpulse.png'),
  hearts: require('resources/images/emoji/hearts.png'),
  heavy_check_mark: require('resources/images/emoji/heavy_check_mark.png'),
  heavy_division_sign: require('resources/images/emoji/heavy_division_sign.png'),
  heavy_dollar_sign: require('resources/images/emoji/heavy_dollar_sign.png'),
  heavy_exclamation_mark: require('resources/images/emoji/heavy_exclamation_mark.png'),
  heavy_minus_sign: require('resources/images/emoji/heavy_minus_sign.png'),
  heavy_multiplication_x: require('resources/images/emoji/heavy_multiplication_x.png'),
  heavy_plus_sign: require('resources/images/emoji/heavy_plus_sign.png'),
  helicopter: require('resources/images/emoji/helicopter.png'),
  herb: require('resources/images/emoji/herb.png'),
  hibiscus: require('resources/images/emoji/hibiscus.png'),
  high_brightness: require('resources/images/emoji/high_brightness.png'),
  high_heel: require('resources/images/emoji/high_heel.png'),
  hocho: require('resources/images/emoji/hocho.png'),
  honey_pot: require('resources/images/emoji/honey_pot.png'),
  honeybee: require('resources/images/emoji/honeybee.png'),
  horse: require('resources/images/emoji/horse.png'),
  horse_racing: require('resources/images/emoji/horse_racing.png'),
  hospital: require('resources/images/emoji/hospital.png'),
  hotel: require('resources/images/emoji/hotel.png'),
  hotsprings: require('resources/images/emoji/hotsprings.png'),
  hourglass: require('resources/images/emoji/hourglass.png'),
  hourglass_flowing_sand: require('resources/images/emoji/hourglass_flowing_sand.png'),
  house: require('resources/images/emoji/house.png'),
  house_with_garden: require('resources/images/emoji/house_with_garden.png'),
  hurtrealbad: require('resources/images/emoji/hurtrealbad.png'),
  hushed: require('resources/images/emoji/hushed.png'),
  ice_cream: require('resources/images/emoji/ice_cream.png'),
  icecream: require('resources/images/emoji/icecream.png'),
  id: require('resources/images/emoji/id.png'),
  ideograph_advantage: require('resources/images/emoji/ideograph_advantage.png'),
  imp: require('resources/images/emoji/imp.png'),
  inbox_tray: require('resources/images/emoji/inbox_tray.png'),
  incoming_envelope: require('resources/images/emoji/incoming_envelope.png'),
  information_desk_person: require('resources/images/emoji/information_desk_person.png'),
  information_source: require('resources/images/emoji/information_source.png'),
  innocent: require('resources/images/emoji/innocent.png'),
  interrobang: require('resources/images/emoji/interrobang.png'),
  iphone: require('resources/images/emoji/iphone.png'),
  it: require('resources/images/emoji/it.png'),
  izakaya_lantern: require('resources/images/emoji/izakaya_lantern.png'),
  jack_o_lantern: require('resources/images/emoji/jack_o_lantern.png'),
  japan: require('resources/images/emoji/japan.png'),
  japanese_castle: require('resources/images/emoji/japanese_castle.png'),
  japanese_goblin: require('resources/images/emoji/japanese_goblin.png'),
  japanese_ogre: require('resources/images/emoji/japanese_ogre.png'),
  jeans: require('resources/images/emoji/jeans.png'),
  joy: require('resources/images/emoji/joy.png'),
  joy_cat: require('resources/images/emoji/joy_cat.png'),
  jp: require('resources/images/emoji/jp.png'),
  key: require('resources/images/emoji/key.png'),
  keycap_ten: require('resources/images/emoji/keycap_ten.png'),
  kimono: require('resources/images/emoji/kimono.png'),
  kiss: require('resources/images/emoji/kiss.png'),
  kissing: require('resources/images/emoji/kissing.png'),
  kissing_cat: require('resources/images/emoji/kissing_cat.png'),
  kissing_closed_eyes: require('resources/images/emoji/kissing_closed_eyes.png'),
  kissing_heart: require('resources/images/emoji/kissing_heart.png'),
  kissing_smiling_eyes: require('resources/images/emoji/kissing_smiling_eyes.png'),
  koala: require('resources/images/emoji/koala.png'),
  koko: require('resources/images/emoji/koko.png'),
  kr: require('resources/images/emoji/kr.png'),
  lantern: require('resources/images/emoji/lantern.png'),
  large_blue_circle: require('resources/images/emoji/large_blue_circle.png'),
  large_blue_diamond: require('resources/images/emoji/large_blue_diamond.png'),
  large_orange_diamond: require('resources/images/emoji/large_orange_diamond.png'),
  last_quarter_moon: require('resources/images/emoji/last_quarter_moon.png'),
  last_quarter_moon_with_face: require('resources/images/emoji/last_quarter_moon_with_face.png'),
  laughing: require('resources/images/emoji/laughing.png'),
  leaves: require('resources/images/emoji/leaves.png'),
  ledger: require('resources/images/emoji/ledger.png'),
  left_luggage: require('resources/images/emoji/left_luggage.png'),
  left_right_arrow: require('resources/images/emoji/left_right_arrow.png'),
  leftwards_arrow_with_hook: require('resources/images/emoji/leftwards_arrow_with_hook.png'),
  lemon: require('resources/images/emoji/lemon.png'),
  leo: require('resources/images/emoji/leo.png'),
  leopard: require('resources/images/emoji/leopard.png'),
  libra: require('resources/images/emoji/libra.png'),
  light_rail: require('resources/images/emoji/light_rail.png'),
  link: require('resources/images/emoji/link.png'),
  lips: require('resources/images/emoji/lips.png'),
  lipstick: require('resources/images/emoji/lipstick.png'),
  lock: require('resources/images/emoji/lock.png'),
  lock_with_ink_pen: require('resources/images/emoji/lock_with_ink_pen.png'),
  lollipop: require('resources/images/emoji/lollipop.png'),
  loop: require('resources/images/emoji/loop.png'),
  loudspeaker: require('resources/images/emoji/loudspeaker.png'),
  love_hotel: require('resources/images/emoji/love_hotel.png'),
  love_letter: require('resources/images/emoji/love_letter.png'),
  low_brightness: require('resources/images/emoji/low_brightness.png'),
  m: require('resources/images/emoji/m.png'),
  mag: require('resources/images/emoji/mag.png'),
  mag_right: require('resources/images/emoji/mag_right.png'),
  mahjong: require('resources/images/emoji/mahjong.png'),
  mailbox: require('resources/images/emoji/mailbox.png'),
  mailbox_closed: require('resources/images/emoji/mailbox_closed.png'),
  mailbox_with_mail: require('resources/images/emoji/mailbox_with_mail.png'),
  mailbox_with_no_mail: require('resources/images/emoji/mailbox_with_no_mail.png'),
  man: require('resources/images/emoji/man.png'),
  man_with_gua_pi_mao: require('resources/images/emoji/man_with_gua_pi_mao.png'),
  man_with_turban: require('resources/images/emoji/man_with_turban.png'),
  mans_shoe: require('resources/images/emoji/mans_shoe.png'),
  maple_leaf: require('resources/images/emoji/maple_leaf.png'),
  mask: require('resources/images/emoji/mask.png'),
  massage: require('resources/images/emoji/massage.png'),
  meat_on_bone: require('resources/images/emoji/meat_on_bone.png'),
  mega: require('resources/images/emoji/mega.png'),
  melon: require('resources/images/emoji/melon.png'),
  memo: require('resources/images/emoji/memo.png'),
  mens: require('resources/images/emoji/mens.png'),
  metal: require('resources/images/emoji/metal.png'),
  metro: require('resources/images/emoji/metro.png'),
  microphone: require('resources/images/emoji/microphone.png'),
  microscope: require('resources/images/emoji/microscope.png'),
  milky_way: require('resources/images/emoji/milky_way.png'),
  minibus: require('resources/images/emoji/minibus.png'),
  minidisc: require('resources/images/emoji/minidisc.png'),
  mobile_phone_off: require('resources/images/emoji/mobile_phone_off.png'),
  money_with_wings: require('resources/images/emoji/money_with_wings.png'),
  moneybag: require('resources/images/emoji/moneybag.png'),
  monkey: require('resources/images/emoji/monkey.png'),
  monkey_face: require('resources/images/emoji/monkey_face.png'),
  monorail: require('resources/images/emoji/monorail.png'),
  moon: require('resources/images/emoji/moon.png'),
  mortar_board: require('resources/images/emoji/mortar_board.png'),
  mount_fuji: require('resources/images/emoji/mount_fuji.png'),
  mountain_bicyclist: require('resources/images/emoji/mountain_bicyclist.png'),
  mountain_cableway: require('resources/images/emoji/mountain_cableway.png'),
  mountain_railway: require('resources/images/emoji/mountain_railway.png'),
  mouse: require('resources/images/emoji/mouse.png'),
  mouse2: require('resources/images/emoji/mouse2.png'),
  movie_camera: require('resources/images/emoji/movie_camera.png'),
  moyai: require('resources/images/emoji/moyai.png'),
  muscle: require('resources/images/emoji/muscle.png'),
  mushroom: require('resources/images/emoji/mushroom.png'),
  musical_keyboard: require('resources/images/emoji/musical_keyboard.png'),
  musical_note: require('resources/images/emoji/musical_note.png'),
  musical_score: require('resources/images/emoji/musical_score.png'),
  mute: require('resources/images/emoji/mute.png'),
  nail_care: require('resources/images/emoji/nail_care.png'),
  name_badge: require('resources/images/emoji/name_badge.png'),
  neckbeard: require('resources/images/emoji/neckbeard.png'),
  necktie: require('resources/images/emoji/necktie.png'),
  negative_squared_cross_mark: require('resources/images/emoji/negative_squared_cross_mark.png'),
  neutral_face: require('resources/images/emoji/neutral_face.png'),
  new: require('resources/images/emoji/new.png'),
  new_moon: require('resources/images/emoji/new_moon.png'),
  new_moon_with_face: require('resources/images/emoji/new_moon_with_face.png'),
  newspaper: require('resources/images/emoji/newspaper.png'),
  ng: require('resources/images/emoji/ng.png'),
  nine: require('resources/images/emoji/nine.png'),
  no_bell: require('resources/images/emoji/no_bell.png'),
  no_bicycles: require('resources/images/emoji/no_bicycles.png'),
  no_entry: require('resources/images/emoji/no_entry.png'),
  no_entry_sign: require('resources/images/emoji/no_entry_sign.png'),
  no_good: require('resources/images/emoji/no_good.png'),
  no_mobile_phones: require('resources/images/emoji/no_mobile_phones.png'),
  no_mouth: require('resources/images/emoji/no_mouth.png'),
  no_pedestrians: require('resources/images/emoji/no_pedestrians.png'),
  no_smoking: require('resources/images/emoji/no_smoking.png'),
  'non-potable_water': require('resources/images/emoji/non-potable_water.png'),
  nose: require('resources/images/emoji/nose.png'),
  notebook: require('resources/images/emoji/notebook.png'),
  notebook_with_decorative_cover: require('resources/images/emoji/notebook_with_decorative_cover.png'),
  notes: require('resources/images/emoji/notes.png'),
  nut_and_bolt: require('resources/images/emoji/nut_and_bolt.png'),
  o: require('resources/images/emoji/o.png'),
  o2: require('resources/images/emoji/o2.png'),
  ocean: require('resources/images/emoji/ocean.png'),
  octocat: require('resources/images/emoji/octocat.png'),
  octopus: require('resources/images/emoji/octopus.png'),
  oden: require('resources/images/emoji/oden.png'),
  office: require('resources/images/emoji/office.png'),
  ok: require('resources/images/emoji/ok.png'),
  ok_hand: require('resources/images/emoji/ok_hand.png'),
  ok_woman: require('resources/images/emoji/ok_woman.png'),
  older_man: require('resources/images/emoji/older_man.png'),
  older_woman: require('resources/images/emoji/older_woman.png'),
  on: require('resources/images/emoji/on.png'),
  oncoming_automobile: require('resources/images/emoji/oncoming_automobile.png'),
  oncoming_bus: require('resources/images/emoji/oncoming_bus.png'),
  oncoming_police_car: require('resources/images/emoji/oncoming_police_car.png'),
  oncoming_taxi: require('resources/images/emoji/oncoming_taxi.png'),
  one: require('resources/images/emoji/one.png'),
  open_book: require('resources/images/emoji/open_book.png'),
  open_file_folder: require('resources/images/emoji/open_file_folder.png'),
  open_hands: require('resources/images/emoji/open_hands.png'),
  open_mouth: require('resources/images/emoji/open_mouth.png'),
  ophiuchus: require('resources/images/emoji/ophiuchus.png'),
  orange_book: require('resources/images/emoji/orange_book.png'),
  outbox_tray: require('resources/images/emoji/outbox_tray.png'),
  ox: require('resources/images/emoji/ox.png'),
  package: require('resources/images/emoji/package.png'),
  page_facing_up: require('resources/images/emoji/page_facing_up.png'),
  page_with_curl: require('resources/images/emoji/page_with_curl.png'),
  pager: require('resources/images/emoji/pager.png'),
  palm_tree: require('resources/images/emoji/palm_tree.png'),
  panda_face: require('resources/images/emoji/panda_face.png'),
  paperclip: require('resources/images/emoji/paperclip.png'),
  parking: require('resources/images/emoji/parking.png'),
  part_alternation_mark: require('resources/images/emoji/part_alternation_mark.png'),
  partly_sunny: require('resources/images/emoji/partly_sunny.png'),
  passport_control: require('resources/images/emoji/passport_control.png'),
  paw_prints: require('resources/images/emoji/paw_prints.png'),
  peach: require('resources/images/emoji/peach.png'),
  pear: require('resources/images/emoji/pear.png'),
  pencil: require('resources/images/emoji/pencil.png'),
  pencil2: require('resources/images/emoji/pencil2.png'),
  penguin: require('resources/images/emoji/penguin.png'),
  pensive: require('resources/images/emoji/pensive.png'),
  performing_arts: require('resources/images/emoji/performing_arts.png'),
  persevere: require('resources/images/emoji/persevere.png'),
  person_frowning: require('resources/images/emoji/person_frowning.png'),
  person_with_blond_hair: require('resources/images/emoji/person_with_blond_hair.png'),
  person_with_pouting_face: require('resources/images/emoji/person_with_pouting_face.png'),
  phone: require('resources/images/emoji/phone.png'),
  pig: require('resources/images/emoji/pig.png'),
  pig2: require('resources/images/emoji/pig2.png'),
  pig_nose: require('resources/images/emoji/pig_nose.png'),
  pill: require('resources/images/emoji/pill.png'),
  pineapple: require('resources/images/emoji/pineapple.png'),
  pisces: require('resources/images/emoji/pisces.png'),
  pizza: require('resources/images/emoji/pizza.png'),
  point_down: require('resources/images/emoji/point_down.png'),
  point_left: require('resources/images/emoji/point_left.png'),
  point_right: require('resources/images/emoji/point_right.png'),
  point_up: require('resources/images/emoji/point_up.png'),
  point_up_2: require('resources/images/emoji/point_up_2.png'),
  police_car: require('resources/images/emoji/police_car.png'),
  poodle: require('resources/images/emoji/poodle.png'),
  poop: require('resources/images/emoji/poop.png'),
  post_office: require('resources/images/emoji/post_office.png'),
  postal_horn: require('resources/images/emoji/postal_horn.png'),
  postbox: require('resources/images/emoji/postbox.png'),
  potable_water: require('resources/images/emoji/potable_water.png'),
  pouch: require('resources/images/emoji/pouch.png'),
  poultry_leg: require('resources/images/emoji/poultry_leg.png'),
  pound: require('resources/images/emoji/pound.png'),
  pouting_cat: require('resources/images/emoji/pouting_cat.png'),
  pray: require('resources/images/emoji/pray.png'),
  princess: require('resources/images/emoji/princess.png'),
  punch: require('resources/images/emoji/punch.png'),
  purple_heart: require('resources/images/emoji/purple_heart.png'),
  purse: require('resources/images/emoji/purse.png'),
  pushpin: require('resources/images/emoji/pushpin.png'),
  put_litter_in_its_place: require('resources/images/emoji/put_litter_in_its_place.png'),
  question: require('resources/images/emoji/question.png'),
  rabbit: require('resources/images/emoji/rabbit.png'),
  rabbit2: require('resources/images/emoji/rabbit2.png'),
  racehorse: require('resources/images/emoji/racehorse.png'),
  radio: require('resources/images/emoji/radio.png'),
  radio_button: require('resources/images/emoji/radio_button.png'),
  rage: require('resources/images/emoji/rage.png'),
  rage1: require('resources/images/emoji/rage1.png'),
  rage2: require('resources/images/emoji/rage2.png'),
  rage3: require('resources/images/emoji/rage3.png'),
  rage4: require('resources/images/emoji/rage4.png'),
  railway_car: require('resources/images/emoji/railway_car.png'),
  rainbow: require('resources/images/emoji/rainbow.png'),
  raised_hand: require('resources/images/emoji/raised_hand.png'),
  raised_hands: require('resources/images/emoji/raised_hands.png'),
  raising_hand: require('resources/images/emoji/raising_hand.png'),
  ram: require('resources/images/emoji/ram.png'),
  ramen: require('resources/images/emoji/ramen.png'),
  rat: require('resources/images/emoji/rat.png'),
  recycle: require('resources/images/emoji/recycle.png'),
  red_car: require('resources/images/emoji/red_car.png'),
  red_circle: require('resources/images/emoji/red_circle.png'),
  registered: require('resources/images/emoji/registered.png'),
  relaxed: require('resources/images/emoji/relaxed.png'),
  relieved: require('resources/images/emoji/relieved.png'),
  repeat: require('resources/images/emoji/repeat.png'),
  repeat_one: require('resources/images/emoji/repeat_one.png'),
  restroom: require('resources/images/emoji/restroom.png'),
  revolving_hearts: require('resources/images/emoji/revolving_hearts.png'),
  rewind: require('resources/images/emoji/rewind.png'),
  ribbon: require('resources/images/emoji/ribbon.png'),
  rice: require('resources/images/emoji/rice.png'),
  rice_ball: require('resources/images/emoji/rice_ball.png'),
  rice_cracker: require('resources/images/emoji/rice_cracker.png'),
  rice_scene: require('resources/images/emoji/rice_scene.png'),
  ring: require('resources/images/emoji/ring.png'),
  rocket: require('resources/images/emoji/rocket.png'),
  roller_coaster: require('resources/images/emoji/roller_coaster.png'),
  rooster: require('resources/images/emoji/rooster.png'),
  rose: require('resources/images/emoji/rose.png'),
  rotating_light: require('resources/images/emoji/rotating_light.png'),
  round_pushpin: require('resources/images/emoji/round_pushpin.png'),
  rowboat: require('resources/images/emoji/rowboat.png'),
  ru: require('resources/images/emoji/ru.png'),
  rugby_football: require('resources/images/emoji/rugby_football.png'),
  runner: require('resources/images/emoji/runner.png'),
  running: require('resources/images/emoji/running.png'),
  running_shirt_with_sash: require('resources/images/emoji/running_shirt_with_sash.png'),
  sa: require('resources/images/emoji/sa.png'),
  sagittarius: require('resources/images/emoji/sagittarius.png'),
  sailboat: require('resources/images/emoji/sailboat.png'),
  sake: require('resources/images/emoji/sake.png'),
  sandal: require('resources/images/emoji/sandal.png'),
  santa: require('resources/images/emoji/santa.png'),
  satellite: require('resources/images/emoji/satellite.png'),
  satisfied: require('resources/images/emoji/satisfied.png'),
  saxophone: require('resources/images/emoji/saxophone.png'),
  school: require('resources/images/emoji/school.png'),
  school_satchel: require('resources/images/emoji/school_satchel.png'),
  scissors: require('resources/images/emoji/scissors.png'),
  scorpius: require('resources/images/emoji/scorpius.png'),
  scream: require('resources/images/emoji/scream.png'),
  scream_cat: require('resources/images/emoji/scream_cat.png'),
  scroll: require('resources/images/emoji/scroll.png'),
  seat: require('resources/images/emoji/seat.png'),
  secret: require('resources/images/emoji/secret.png'),
  see_no_evil: require('resources/images/emoji/see_no_evil.png'),
  seedling: require('resources/images/emoji/seedling.png'),
  seven: require('resources/images/emoji/seven.png'),
  shaved_ice: require('resources/images/emoji/shaved_ice.png'),
  sheep: require('resources/images/emoji/sheep.png'),
  shell: require('resources/images/emoji/shell.png'),
  ship: require('resources/images/emoji/ship.png'),
  shipit: require('resources/images/emoji/shipit.png'),
  shirt: require('resources/images/emoji/shirt.png'),
  shit: require('resources/images/emoji/shit.png'),
  shoe: require('resources/images/emoji/shoe.png'),
  shower: require('resources/images/emoji/shower.png'),
  signal_strength: require('resources/images/emoji/signal_strength.png'),
  six: require('resources/images/emoji/six.png'),
  six_pointed_star: require('resources/images/emoji/six_pointed_star.png'),
  ski: require('resources/images/emoji/ski.png'),
  skull: require('resources/images/emoji/skull.png'),
  sleeping: require('resources/images/emoji/sleeping.png'),
  sleepy: require('resources/images/emoji/sleepy.png'),
  slot_machine: require('resources/images/emoji/slot_machine.png'),
  small_blue_diamond: require('resources/images/emoji/small_blue_diamond.png'),
  small_orange_diamond: require('resources/images/emoji/small_orange_diamond.png'),
  small_red_triangle: require('resources/images/emoji/small_red_triangle.png'),
  small_red_triangle_down: require('resources/images/emoji/small_red_triangle_down.png'),
  smile: require('resources/images/emoji/smile.png'),
  smile_cat: require('resources/images/emoji/smile_cat.png'),
  smiley: require('resources/images/emoji/smiley.png'),
  smiley_cat: require('resources/images/emoji/smiley_cat.png'),
  smiling_imp: require('resources/images/emoji/smiling_imp.png'),
  smirk: require('resources/images/emoji/smirk.png'),
  smirk_cat: require('resources/images/emoji/smirk_cat.png'),
  smoking: require('resources/images/emoji/smoking.png'),
  snail: require('resources/images/emoji/snail.png'),
  snake: require('resources/images/emoji/snake.png'),
  snowboarder: require('resources/images/emoji/snowboarder.png'),
  snowflake: require('resources/images/emoji/snowflake.png'),
  snowman: require('resources/images/emoji/snowman.png'),
  sob: require('resources/images/emoji/sob.png'),
  soccer: require('resources/images/emoji/soccer.png'),
  soon: require('resources/images/emoji/soon.png'),
  sos: require('resources/images/emoji/sos.png'),
  sound: require('resources/images/emoji/sound.png'),
  space_invader: require('resources/images/emoji/space_invader.png'),
  spades: require('resources/images/emoji/spades.png'),
  spaghetti: require('resources/images/emoji/spaghetti.png'),
  sparkle: require('resources/images/emoji/sparkle.png'),
  sparkler: require('resources/images/emoji/sparkler.png'),
  sparkles: require('resources/images/emoji/sparkles.png'),
  sparkling_heart: require('resources/images/emoji/sparkling_heart.png'),
  speak_no_evil: require('resources/images/emoji/speak_no_evil.png'),
  speaker: require('resources/images/emoji/speaker.png'),
  speech_balloon: require('resources/images/emoji/speech_balloon.png'),
  speedboat: require('resources/images/emoji/speedboat.png'),
  squirrel: require('resources/images/emoji/squirrel.png'),
  star: require('resources/images/emoji/star.png'),
  star2: require('resources/images/emoji/star2.png'),
  stars: require('resources/images/emoji/stars.png'),
  station: require('resources/images/emoji/station.png'),
  statue_of_liberty: require('resources/images/emoji/statue_of_liberty.png'),
  steam_locomotive: require('resources/images/emoji/steam_locomotive.png'),
  stew: require('resources/images/emoji/stew.png'),
  straight_ruler: require('resources/images/emoji/straight_ruler.png'),
  strawberry: require('resources/images/emoji/strawberry.png'),
  stuck_out_tongue: require('resources/images/emoji/stuck_out_tongue.png'),
  stuck_out_tongue_closed_eyes: require('resources/images/emoji/stuck_out_tongue_closed_eyes.png'),
  stuck_out_tongue_winking_eye: require('resources/images/emoji/stuck_out_tongue_winking_eye.png'),
  sun_with_face: require('resources/images/emoji/sun_with_face.png'),
  sunflower: require('resources/images/emoji/sunflower.png'),
  sunglasses: require('resources/images/emoji/sunglasses.png'),
  sunny: require('resources/images/emoji/sunny.png'),
  sunrise: require('resources/images/emoji/sunrise.png'),
  sunrise_over_mountains: require('resources/images/emoji/sunrise_over_mountains.png'),
  surfer: require('resources/images/emoji/surfer.png'),
  sushi: require('resources/images/emoji/sushi.png'),
  suspect: require('resources/images/emoji/suspect.png'),
  suspension_railway: require('resources/images/emoji/suspension_railway.png'),
  sweat: require('resources/images/emoji/sweat.png'),
  sweat_drops: require('resources/images/emoji/sweat_drops.png'),
  sweat_smile: require('resources/images/emoji/sweat_smile.png'),
  sweet_potato: require('resources/images/emoji/sweet_potato.png'),
  swimmer: require('resources/images/emoji/swimmer.png'),
  symbols: require('resources/images/emoji/symbols.png'),
  syringe: require('resources/images/emoji/syringe.png'),
  tada: require('resources/images/emoji/tada.png'),
  tanabata_tree: require('resources/images/emoji/tanabata_tree.png'),
  tangerine: require('resources/images/emoji/tangerine.png'),
  taurus: require('resources/images/emoji/taurus.png'),
  taxi: require('resources/images/emoji/taxi.png'),
  tea: require('resources/images/emoji/tea.png'),
  telephone: require('resources/images/emoji/telephone.png'),
  telephone_receiver: require('resources/images/emoji/telephone_receiver.png'),
  telescope: require('resources/images/emoji/telescope.png'),
  tennis: require('resources/images/emoji/tennis.png'),
  tent: require('resources/images/emoji/tent.png'),
  thought_balloon: require('resources/images/emoji/thought_balloon.png'),
  three: require('resources/images/emoji/three.png'),
  thumbsdown: require('resources/images/emoji/thumbsdown.png'),
  thumbsup: require('resources/images/emoji/thumbsup.png'),
  ticket: require('resources/images/emoji/ticket.png'),
  tiger: require('resources/images/emoji/tiger.png'),
  tiger2: require('resources/images/emoji/tiger2.png'),
  tired_face: require('resources/images/emoji/tired_face.png'),
  tm: require('resources/images/emoji/tm.png'),
  toilet: require('resources/images/emoji/toilet.png'),
  tokyo_tower: require('resources/images/emoji/tokyo_tower.png'),
  tomato: require('resources/images/emoji/tomato.png'),
  tongue: require('resources/images/emoji/tongue.png'),
  top: require('resources/images/emoji/top.png'),
  tophat: require('resources/images/emoji/tophat.png'),
  tractor: require('resources/images/emoji/tractor.png'),
  traffic_light: require('resources/images/emoji/traffic_light.png'),
  train: require('resources/images/emoji/train.png'),
  train2: require('resources/images/emoji/train2.png'),
  tram: require('resources/images/emoji/tram.png'),
  trello: require('resources/images/emoji/trello.png'),
  triangular_flag_on_post: require('resources/images/emoji/triangular_flag_on_post.png'),
  triangular_ruler: require('resources/images/emoji/triangular_ruler.png'),
  trident: require('resources/images/emoji/trident.png'),
  triumph: require('resources/images/emoji/triumph.png'),
  trolleybus: require('resources/images/emoji/trolleybus.png'),
  trollface: require('resources/images/emoji/trollface.png'),
  trophy: require('resources/images/emoji/trophy.png'),
  tropical_drink: require('resources/images/emoji/tropical_drink.png'),
  tropical_fish: require('resources/images/emoji/tropical_fish.png'),
  truck: require('resources/images/emoji/truck.png'),
  trumpet: require('resources/images/emoji/trumpet.png'),
  tshirt: require('resources/images/emoji/tshirt.png'),
  tulip: require('resources/images/emoji/tulip.png'),
  turtle: require('resources/images/emoji/turtle.png'),
  tv: require('resources/images/emoji/tv.png'),
  twisted_rightwards_arrows: require('resources/images/emoji/twisted_rightwards_arrows.png'),
  two: require('resources/images/emoji/two.png'),
  two_hearts: require('resources/images/emoji/two_hearts.png'),
  two_men_holding_hands: require('resources/images/emoji/two_men_holding_hands.png'),
  two_women_holding_hands: require('resources/images/emoji/two_women_holding_hands.png'),
  u5272: require('resources/images/emoji/u5272.png'),
  u5408: require('resources/images/emoji/u5408.png'),
  u55b6: require('resources/images/emoji/u55b6.png'),
  u6307: require('resources/images/emoji/u6307.png'),
  u6708: require('resources/images/emoji/u6708.png'),
  u6709: require('resources/images/emoji/u6709.png'),
  u6e80: require('resources/images/emoji/u6e80.png'),
  u7121: require('resources/images/emoji/u7121.png'),
  u7533: require('resources/images/emoji/u7533.png'),
  u7981: require('resources/images/emoji/u7981.png'),
  u7a7a: require('resources/images/emoji/u7a7a.png'),
  uk: require('resources/images/emoji/uk.png'),
  umbrella: require('resources/images/emoji/umbrella.png'),
  unamused: require('resources/images/emoji/unamused.png'),
  underage: require('resources/images/emoji/underage.png'),
  unlock: require('resources/images/emoji/unlock.png'),
  up: require('resources/images/emoji/up.png'),
  us: require('resources/images/emoji/us.png'),
  v: require('resources/images/emoji/v.png'),
  vertical_traffic_light: require('resources/images/emoji/vertical_traffic_light.png'),
  vhs: require('resources/images/emoji/vhs.png'),
  vibration_mode: require('resources/images/emoji/vibration_mode.png'),
  video_camera: require('resources/images/emoji/video_camera.png'),
  video_game: require('resources/images/emoji/video_game.png'),
  violin: require('resources/images/emoji/violin.png'),
  virgo: require('resources/images/emoji/virgo.png'),
  volcano: require('resources/images/emoji/volcano.png'),
  vs: require('resources/images/emoji/vs.png'),
  walking: require('resources/images/emoji/walking.png'),
  waning_crescent_moon: require('resources/images/emoji/waning_crescent_moon.png'),
  waning_gibbous_moon: require('resources/images/emoji/waning_gibbous_moon.png'),
  warning: require('resources/images/emoji/warning.png'),
  watch: require('resources/images/emoji/watch.png'),
  water_buffalo: require('resources/images/emoji/water_buffalo.png'),
  watermelon: require('resources/images/emoji/watermelon.png'),
  wave: require('resources/images/emoji/wave.png'),
  wavy_dash: require('resources/images/emoji/wavy_dash.png'),
  waxing_crescent_moon: require('resources/images/emoji/waxing_crescent_moon.png'),
  waxing_gibbous_moon: require('resources/images/emoji/waxing_gibbous_moon.png'),
  wc: require('resources/images/emoji/wc.png'),
  weary: require('resources/images/emoji/weary.png'),
  wedding: require('resources/images/emoji/wedding.png'),
  whale: require('resources/images/emoji/whale.png'),
  whale2: require('resources/images/emoji/whale2.png'),
  wheelchair: require('resources/images/emoji/wheelchair.png'),
  white_check_mark: require('resources/images/emoji/white_check_mark.png'),
  white_circle: require('resources/images/emoji/white_circle.png'),
  white_flower: require('resources/images/emoji/white_flower.png'),
  white_large_square: require('resources/images/emoji/white_large_square.png'),
  white_medium_small_square: require('resources/images/emoji/white_medium_small_square.png'),
  white_medium_square: require('resources/images/emoji/white_medium_square.png'),
  white_small_square: require('resources/images/emoji/white_small_square.png'),
  white_square_button: require('resources/images/emoji/white_square_button.png'),
  wind_chime: require('resources/images/emoji/wind_chime.png'),
  wine_glass: require('resources/images/emoji/wine_glass.png'),
  wink: require('resources/images/emoji/wink.png'),
  wolf: require('resources/images/emoji/wolf.png'),
  woman: require('resources/images/emoji/woman.png'),
  womans_clothes: require('resources/images/emoji/womans_clothes.png'),
  womans_hat: require('resources/images/emoji/womans_hat.png'),
  womens: require('resources/images/emoji/womens.png'),
  worried: require('resources/images/emoji/worried.png'),
  wrench: require('resources/images/emoji/wrench.png'),
  x: require('resources/images/emoji/x.png'),
  yellow_heart: require('resources/images/emoji/yellow_heart.png'),
  yen: require('resources/images/emoji/yen.png'),
  yum: require('resources/images/emoji/yum.png'),
  zap: require('resources/images/emoji/zap.png'),
  zero: require('resources/images/emoji/zero.png'),
  zzz: require('resources/images/emoji/zzz.png'),
} as { [key: string]: string };
